import logo from "@/assets/logo2024.webp.asset.json";

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border bg-primary text-primary-foreground">
      <div className="mx-auto max-w-6xl px-6 py-16 grid gap-10 md:grid-cols-3">
        <div>
          <img
            src={logo.url}
            alt="Bauer IP"
            className="h-10 w-auto mb-5 bg-primary-foreground rounded-md px-3 py-2"
            width={140}
            height={40}
          />
          <p className="text-sm text-primary-foreground/80 leading-relaxed">
            Karel Bauer<br />
            European Patent Attorney<br />
            European Trademark Attorney<br />
            Unified Patent Court Representative
          </p>
        </div>
        <div className="text-sm text-primary-foreground/80 space-y-1">
          <p className="eyebrow mb-3" style={{ color: "var(--accent)" }}>Office</p>
          <p>124 City Road, London EC1V 2NX</p>
          <p>UK</p>
        </div>
        <div className="text-sm space-y-1">
          <p className="eyebrow mb-3" style={{ color: "var(--accent)" }}>Contact</p>
          <p>
            <a href="mailto:docket@bauerip.com" className="text-primary-foreground hover:text-accent transition-colors">
              docket@bauerip.com
            </a>
          </p>
          <p className="text-primary-foreground/80">
            <a href="tel:+420608785607" className="hover:text-accent transition-colors">
              +420 608 785 607
            </a>
          </p>
          <p>
            <a
              href="https://www.linkedin.com/in/karelbauer/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-foreground/80 hover:text-accent transition-colors"
            >
              LinkedIn →
            </a>
          </p>
        </div>
      </div>
      <div className="border-t border-primary-foreground/15">
        <div className="mx-auto max-w-6xl px-6 py-5 text-xs text-primary-foreground/60 flex flex-wrap justify-between gap-2">
          <span>© {new Date().getFullYear()} Karel Bauer. All rights reserved.</span>
          <span className="flex flex-wrap items-center gap-4">
            <a href="/terms" className="hover:text-accent transition-colors">
              General Terms and Conditions
            </a>
            <span>European Patent &amp; Trade Mark practice · UPC representation</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
